module.exports = __webpack_public_path__ + "static/media/FitnessGuru.ccb6e1d9.svg";